export default __webpack_public_path__ + "static/media/FleetMonitoring300.f365828e.jpg";